module.exports = __webpack_public_path__ + "icon_delete_gray.74803.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_delete_gray.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_delete_gray.svg
// module chunks = main